import { ButtonType, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type addNodeButton_CreateBranchChildMutation } from "@relay/addNodeButton_CreateBranchChildMutation.graphql";
import { type addNodeButton_CreateContentChildMutation } from "@relay/addNodeButton_CreateContentChildMutation.graphql";
import {
	CREATE_BRANCH_CHILD_MUTATION,
	CREATE_CONTENT_CHILD_MUTATION,
} from "./add-node-button.graphql";
import { type AddNodeButtonProps } from "./add-node-button.types";
import { buttonWrapperClass } from "./add-note-button-styles";
import { Button } from "../../../../components/button";
import { TREE_I18N_KEY, TREE_I18N_MAP } from "../../../../translations/tree";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const AddNodeButton = ({ parentBranchId, onSuccessful }: AddNodeButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createBranchChild, isCreatingBranchChild] =
		useMutation<addNodeButton_CreateBranchChildMutation>(CREATE_BRANCH_CHILD_MUTATION);

	const [createContentChild, isCreatingContentChild] =
		useMutation<addNodeButton_CreateContentChildMutation>(CREATE_CONTENT_CHILD_MUTATION);

	const onCreateBranchChildClick = () => {
		if (!parentBranchId) return;

		createBranchChild({
			variables: {
				input: {
					parentBranchId,
					title: TREE_I18N_MAP(TREE_I18N_KEY.newBranchNode),
				},
			},
			updater: setDraft,
			onCompleted: (response) => {
				onSuccessful(response.Admin.Tree.createBranchChild?.createdChildNode.id);
			},
		});
	};

	const onCreateContentChildClick = () => {
		if (!parentBranchId) return;

		createContentChild({
			variables: {
				input: {
					contentKind: "ELearning",
					parentBranchId,
					title: TREE_I18N_MAP(TREE_I18N_KEY.newELearningContentNode),
				},
			},
			updater: setDraft,
			onCompleted: (response) => {
				onSuccessful(response.Admin.Tree.createContentChild?.createdChildNode.id);
			},
		});
	};

	return (
		<div className={buttonWrapperClass}>
			<Button
				type={ButtonType.Button}
				icon={EpicIcons.SITEMAP}
				tooltip={t("educationalOffer.createNode", {
					type: TREE_I18N_MAP(TREE_I18N_KEY.branchNode),
				})}
				disabled={parentBranchId === undefined || isCreatingBranchChild}
				onClick={onCreateBranchChildClick}
			/>
			<Button
				type={ButtonType.Button}
				icon={EpicIcons.FILE}
				tooltip={t("educationalOffer.createNode", {
					type: TREE_I18N_MAP(TREE_I18N_KEY.eLearningContentNode),
				})}
				disabled={parentBranchId === undefined || isCreatingContentChild}
				onClick={onCreateContentChildClick}
			/>
		</div>
	);
};
